import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import withAuthentication from '../../../../core/login/withAuthentication';
import { MAX_NUMBER_CUSTOM_FIELDS_PER_PAGE } from '../../paperworkConstants';
import CustomPaperworkFieldsForm from './CustomPaperworkFieldsForm';
import { SectionNumber } from '../../constants';
import { GenericSection } from '../Sections/GenericSection';

const PaperworkCustom = () => {
  const paperwork = useSelector((state) => state.paperwork);

  const customPages = useMemo(() => {
    const pages = new Map();
    if (paperwork.customFields) {
      const customFields = [...paperwork.customFields];
      let i = 0;
      let chunk;
      while (customFields.length > 0) {
        chunk = customFields.splice(0, MAX_NUMBER_CUSTOM_FIELDS_PER_PAGE);
        pages.set(i, { fields: chunk, fieldNames: chunk.map((field) => field?.field_name) });
        i += 1;
      }
    }
    return pages;
  }, [paperwork.customFields]);

  return (
    <GenericSection
      formComponent={CustomPaperworkFieldsForm}
      pageCollection={customPages}
      section={SectionNumber}
      sectionValue={SectionNumber.Custom}
    />
  );
};

export default withAuthentication(PaperworkCustom);
